import styled from "styled-components";

interface containerProps {
    nameColor?: string;
  }

export const TextContent = styled.div<containerProps>`
    display: flex;
    text-align: center;
    justify-content: center;
    width: 95%;
    margin: 2%;

`;

export const TextP = styled.p<containerProps>`
    color: var(--orange);
    background-color: ${props => props.nameColor === "INÍCIO" ? 'var(--orange)': 'rgba(0, 0, 0, 0.8)'};
    width:  ${props => props.nameColor === "INÍCIO" ? '100%': '95%'};
    font-weight: bold;
    border-radius: 10px;
    padding: 3%;
`;